/* tslint:disable:max-line-length */
import {FuseNavigationItem} from "fuseui";

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Přehled',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/dashboard',
        role : 'other',
    },
    {
        id   : 'users',
        title: 'Zaměstnanci',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/users',
        role : 'other',
    },
    {
        id   : 'device',
        title: 'Zařízení',
        type : 'basic',
        icon : 'heroicons_outline:chip',
        link : '/devices',
        role : 'other',
    },
    {
        id   : 'actions',
        title: 'Akce',
        type : 'basic',
        icon : 'heroicons_outline:lightning-bolt',
        link : '/actions',
        role : 'other',
    },
    {
        id   : 'Cards',
        title: 'Karty',
        type : 'basic',
        icon : 'heroicons_outline:credit-card',
        link : '/cards',
        role : 'other',
    },
    {
        id   : 'centers',
        title: 'Střediska',
        type : 'basic',
        icon : 'heroicons_outline:office-building',
        link : '/centers',
        role : 'other',
    },
    {
        id   : 'groups',
        title: 'Uživatelské skupiny',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/groups',
        role : 'other',
    },
    {
        id   : 'attendences',
        title: 'Docházka',
        type : 'basic',
        icon : 'heroicons_outline:bookmark-alt',
        link : '/attendences',
        role : 'other',
    },
    {
        id      : 'app-group',
        title   : 'Aplikace ZAS',
        subtitle: 'Vše co potřebujete vědět',
        type    : 'group',
        children: [
            {
                id   : 'support',
                title: 'Podpora',
                type : 'basic',
                icon : 'heroicons_outline:question-mark-circle',
                link : '/support'
            },
            {
                id   : 'changelog',
                title: 'Changelog',
                type : 'basic',
                icon : 'heroicons_outline:newspaper',
                link : '/changelog'
            }
        ]
    },
    ];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Přehled',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/dashboard',
        role : 'other',
    },
    {
        id   : 'users',
        title: 'Zaměstnanci',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/users',
        role : 'other',
    },
    {
        id   : 'device',
        title: 'Zařízení',
        type : 'basic',
        icon : 'heroicons_outline:chip',
        link : '/devices',
        role : 'other',
    },
    {
        id   : 'actions',
        title: 'Akce',
        type : 'basic',
        icon : 'heroicons_outline:lightning-bolt',
        link : '/actions',
        role : 'other',
    },
    {
        id   : 'Cards',
        title: 'Karty',
        type : 'basic',
        icon : 'heroicons_outline:credit-card',
        link : '/cards',
        role : 'other',
    },
    {
        id   : 'centers',
        title: 'Střediska',
        type : 'basic',
        icon : 'heroicons_outline:office-building',
        link : '/centers',
        role : 'other',
    },
    {
        id   : 'groups',
        title: 'Uživatelské skupiny',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/groups',
        role : 'other',
    },
    {
        id   : 'attendences',
        title: 'Docházka',
        type : 'basic',
        icon : 'heroicons_outline:bookmark-alt',
        link : '/attendences',
        role : 'other',
    },

    {
        id      : 'app-group',
        title   : 'Aplikace ZAS',
        subtitle: 'Vše co potřebujete vědět',
        type    : 'group',
        children: [
            {
                id   : 'support',
                title: 'Podpora',
                type : 'basic',
                icon : 'heroicons_outline:question-mark-circle',
                link : '/support'
            },
            {
                id   : 'changelog',
                title: 'Changelog',
                type : 'basic',
                icon : 'heroicons_outline:newspaper',
                link : '/changelog'
            }
        ]
    }
];

export const defaultNavigationNotAdmin: FuseNavigationItem[] = [
    {
        id   : 'users',
        title: 'Zaměstnanci',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/users',
        role : 'other',
    },
    {
        id   : 'Cards',
        title: 'Karty',
        type : 'basic',
        icon : 'heroicons_outline:credit-card',
        link : '/cards',
        role : 'other',
    },
    {
        id   : 'attendences',
        title: 'Docházka',
        type : 'basic',
        icon : 'heroicons_outline:bookmark-alt',
        link : '/attendences',
        role : 'other',
    }
];

export const horizontalNavigationNotAdmin: FuseNavigationItem[] = [
    {
        id   : 'users',
        title: 'Zaměstnanci',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/users',
        role : 'other',
    },
    {
        id   : 'Cards',
        title: 'Karty',
        type : 'basic',
        icon : 'heroicons_outline:credit-card',
        link : '/cards',
        role : 'other',
    },
    {
        id   : 'attendences',
        title: 'Docházka',
        type : 'basic',
        icon : 'heroicons_outline:bookmark-alt',
        link : '/attendences',
        role : 'other',
    }
];
